import React from 'react';
import {useSession} from "./SessionContext";
import {Navigate, Outlet, useLocation} from "react-router";

const ProtectedRoute = () => {
    const { isAuthenticated } = useSession();
    const location = useLocation();

    return isAuthenticated ? <Outlet /> : <Navigate to="/" state={{ from: location, message: 'You need to log in to access this page.' }} />;
};

export default ProtectedRoute;